import React from 'react';
import { Link } from 'react-router-dom';

export default function LegalPageLayout({ title, effectiveDate, children }) {
  return (
    <main className="min-h-screen bg-[var(--brand-bg)] px-4 py-8 sm:px-6 sm:py-12">
      <article className="mx-auto max-w-3xl bg-white border border-[var(--brand-border)] shadow-sm">
        <header className="border-b border-[var(--brand-border)] px-6 py-7 sm:px-10">
          <Link to="/" className="text-sm font-semibold text-[var(--brand-primary)] hover:underline">
            GetScribeDash
          </Link>
          <h1 className="mt-3 text-3xl font-black tracking-tight text-[var(--brand-text)]">{title}</h1>
          <p className="mt-2 text-sm text-[var(--brand-text-sec)]">Effective {effectiveDate}</p>
        </header>
        <div className="space-y-8 px-6 py-8 text-[var(--brand-text-sec)] sm:px-10 [&_h2]:mb-3 [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-[var(--brand-text)] [&_li]:mb-2 [&_p]:leading-7 [&_ul]:list-disc [&_ul]:pl-6">
          {children}
        </div>
        <footer className="border-t border-[var(--brand-border)] px-6 py-5 text-sm sm:px-10">
          <Link to="/terms" className="text-[var(--brand-primary)] hover:underline">Terms</Link>
          <span aria-hidden="true"> · </span>
          <Link to="/privacy" className="text-[var(--brand-primary)] hover:underline">Privacy</Link>
          <span aria-hidden="true"> · </span>
          <Link to="/" className="text-[var(--brand-primary)] hover:underline">Return to GetScribeDash</Link>
        </footer>
      </article>
    </main>
  );
}
